import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { RoleService } from '../services/RoleManagement/role.service';

@Component({
  selector: 'app-app-user',
  templateUrl: './app-user.component.html',
  styleUrls: ['./app-user.component.scss']
})
export class AppUserComponent {
  loggedUserId: number = 0;
  appUserPath: string = "";
  isAppUserBoard: boolean | null = null;
  hideSidebar: boolean = false;
  isToursModule: boolean = false;

  constructor(private router: Router, private roleService: RoleService) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd || 
          (event.constructor.name === 'ActivationEnd' || event.constructor.name === 'ChildActivationEnd')) {
        
        const tourPaths = ['/tour', '/book-tour', '/my-tours', '/schedule-a-tour', '/Feedback-view'];
        // Set timeout to ensure the path updates before rendering
        setTimeout(() => {
          this.appUserPath = this.router.url;
          // this.isAppUserBoard = !this.appUserPath.startsWith('/tour');  // changed for new routing
          this.isAppUserBoard = !tourPaths.some(path => this.appUserPath.startsWith(path));
          this.hideSidebar = this.shouldHideSidebar(this.appUserPath);
          //this.isToursModule = this.appUserPath.includes('/tour'); // changed for new routing
          this.isToursModule = tourPaths.some(path => this.appUserPath.includes(path));
        });
      }
    });

    // Initialize loggedUserId
    this.roleService.userDetail$.subscribe(detail => {
      this.loggedUserId = detail.userId
    })
    if (!(this.loggedUserId > 0)) {
      // Redirect or handle unauthenticated user
    }
  }

  // Helper method for sidebar visibility
  private shouldHideSidebar(url: string): boolean {
    const hidePaths = ['guide', 'add-listing', 'my-listings', 'dashboard', 'detailed-listing-view', 'search', 'information-posts', 'saved-search'];
    return hidePaths.some(path => url.includes(path));
  }
}
